// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalEligibilityResponse } from './medicalEligibilityResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1MedicalV1MedicalEligibilityDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': MedicalEligibilityResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1MedicalV1MedicalEligibilityDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "MedicalEligibilityResponse"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1MedicalV1MedicalEligibilityDefaultResponse.attributeTypeMap;
    }
}
